'use client';
const ModalDialogVariantEnum = {
    Standard: 'standard',
    PanelRight: 'panel-right',
    PanelLeft: 'panel-left',
    PanelBottom: 'panel-bottom',
    PanelTop: 'panel-top',
    Menu: 'menu'
};
const ModalDialogBodyWidths = [
    'standard',
    'capped',
    'grow'
];

export { ModalDialogBodyWidths, ModalDialogVariantEnum };
